<template lang="pug">
  shListData(title="Methods History" resolver="methodsHistory" keyData="_id" component="shMethod" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'MethodsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/method/MethodsHistory.vue